import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  meta: {
    count: 0,
    currentPage: 1,
  },
  records: {},
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isFetchingInboxes: false,
    isUpdating: false,
    isMerging: false,
    isDeleting: false,
  },
  sortOrder: [],
  appliedFilters: [],
  // The last presence snapshot, as its own map: { [contactId]: 'online' }. Null until the first
  // one arrives. Kept apart from `records` on purpose — a contact.updated event REPLACES the record
  // (EDIT_CONTACT) with a payload that carries no availability_status, so presence read from the
  // record vanished on every customer message. Read by the uniPLUS presence chip only.
  presence: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
